import React from 'react'
import { Edit } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import BasePackageForm from '../BasePackageForm'

const MusicPackageEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.musicpackages.editPackage'}>
      <Edit>
        <BasePackageForm entity="musics" />
      </Edit>
    </SectionWrapper>
  )
}

export default MusicPackageEdit
